<template>
  <div>
    <slot name="opener" v-bind:openModal="openModal" />

    <modal
      :visible="modalVisible"
      :visibleFooter="visibleFooter"
      @close="closeModal"
    >
      <slot name="modal-content" v-bind:closeModal="closeModal" />
    </modal>
  </div>
</template>

<script>
import Modal from './Modal';

export default {
  components: { Modal },
  props: {
    visibleFooter: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      modalVisible: false
    };
  },

  methods: {
    openModal() {
      this.modalVisible = true;
    },

    closeModal() {
      this.modalVisible = false;
      this.$emit('close');
    }
  }
};
</script>
